import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { formatTokens } from '@/services/usage/usageMappers'
import { planUsageTokenStatSx, planUsageTokenStatsRowSx } from './planUsageTokenStatsSx.js'

function Stat({ label, value }) {
  return (
    <Stack spacing={0.25} sx={planUsageTokenStatSx}>
      <Typography component="span" variant="h6" fontWeight={600}>{value}</Typography>
      <Typography component="span" variant="caption" color="text.secondary">{label}</Typography>
    </Stack>
  )
}

/** @param {{ totals?: object, configured?: boolean, isLoading?: boolean }} props */
export function PlanUsageTokenTotals({ totals, configured, isLoading }) {
  if (isLoading) return <Typography variant="body2" color="text.secondary">Loading usage…</Typography>
  if (!configured) {
    return (
      <Typography variant="body2" color="text.secondary">
        Usage tracking is not enabled for this workspace.
      </Typography>
    )
  }
  const counts = totals ?? {}
  return (
    <Stack direction="row" useFlexGap flexWrap="wrap" sx={planUsageTokenStatsRowSx}>
      <Stat label="Total tokens" value={formatTokens(counts.total_tokens)} />
      <Stat label="Input" value={formatTokens(counts.input_tokens)} />
      <Stat label="Output" value={formatTokens(counts.output_tokens)} />
      <Stat label="Cached" value={formatTokens(counts.cache_read_tokens)} />
      <Stat label="Requests" value={formatTokens(counts.api_calls)} />
    </Stack>
  )
}
